import { useContext, useState } from "react";
import logo from "@assets/images/authorizenet/authorizenet-logo.png";
import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import SupplierContext from "@contexts/SupplierContext";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import UserContext from "@contexts/UserContext";
import { SocketContext } from "@contexts/SocketContext";
import EndpointsEnum from "@models/EndpointsEnum";
import IUpdateSupplierIntegrationsDTO from "@models/DTO/IUpdateSupplierIntegrationsDTO";
import { OwFnInput } from "@components/shared/OwFnInput/OwFnInput";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwButton from "@components/shared/OwButton/OwButton";

type Props = {};

export const AuthorizeNetConnect = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;

    const [loginId, setLoginId] = useState(supplierModel.Supplier_Integration.authnet_login_id);
    const [transactionKey, setTransactionKey] = useState();
    const [publicClientKey, setPublicClientKey] = useState(supplierModel.Supplier_Integration.authnet_public_client_key);

    const toggleAuthorizeNet = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_authnet: !supplierModel.Supplier_Integration.has_authnet,
            },
        };

        socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === "login_id") {
            setLoginId(value);
        }

        if (name === "transaction_key") {
            setTransactionKey(value);
        }

        if (name === "public_client_key") {
            setPublicClientKey(value);
        }
    };

    const handleSave = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                authnet_login_id: loginId,
                authnet_public_client_key: publicClientKey,
            },
        };

        if (transactionKey) {
            payload.Supplier_Integration.authnet_tx_key = transactionKey;
        }

        socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    return (
        <div className={"AuthorizeNetConnect"}>
            <OwAccordion
                hideChevron={!supplierModel.Supplier_Integration.has_authnet}
                fullWidthClick={true}
                leftImage={logo}
                leftImageHeight={30}
                titleClick={false}
                rightElem={
                    <div className={"ms-auto"}>
                        <OwToggle
                            active={!!supplierModel.Supplier_Integration.has_authnet}
                            name={"toggleAuthorizeNet"}
                            fn={toggleAuthorizeNet}
                            label={""}
                        />
                    </div>
                }>
                <div>
                    <div>
                        <OwLabel title={"login_id"} />
                        <OwFnInput name="login_id" fn={handleChange} value={loginId} />
                    </div>
                    <div className="mb-2">
                        <OwLabel title={"transaction_key"} />
                        <OwFnInput name="transaction_key" fn={handleChange} value={transactionKey} />
                        <div>
                            {supplierModel.Supplier_Integration.authnet_tx_key ? (
                                <OwLabel title="set" leftIconClass="fas fa-check-circle text-success" />
                            ) : null}
                        </div>
                    </div>
                    <div className="mb-2">
                        <OwLabel title="public_client_key" />
                        <OwFnInput name="public_client_key" fn={handleChange} value={publicClientKey} />
                    </div>
                    <div className="mb-2">
                        <OwButton title="save" fn={handleSave} />
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
